import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles/app.css';
import { projectAuth } from './firebase/config';
import './registerServiceWorker';
import VueKonva from 'vue-konva';

// Initialize app variable
let app;

// Listen for Firebase auth state changes
projectAuth.onAuthStateChanged(() => {
  // Only mount the app if it hasn't been mounted yet
  if (!app) {
    app = createApp(App);
    app.use(router);
    app.use(VueKonva); // Register vue-konva plugin
    app.mount('#app');
  }
});